import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { ImagePicker } from 'react-file-picker'
import { renderAlert } from '../../services/render-alert'
import ImageIcon from 'material-ui/svg-icons/image/image'
import CreateIcon from '../assets/CreateIcon'
import CaratIcon from '../assets/CaratIcon'
import InsertTemplateIcon from '../assets/InsertTemplate'
import DeleteTemplateIcon from 'material-ui/svg-icons/action/delete'
import styles from './styles/MessageOptionsModal.css'

import TemplateSelect from './TemplateSelect'

const cx = classNames.bind(styles)

class MessageOptionsModal extends Component {
  static propTypes = {
    closeOptionsModal: PropTypes.func.isRequired,
    handleTemplateSelection: PropTypes.func.isRequired,
    isBlastMsg: PropTypes.bool,
    isEmail: PropTypes.bool.isRequired,
    hideImgPicker: PropTypes.bool.isRequired,
    previewPendingMedia: PropTypes.func,
    templateSettings: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  }

  filteredSettings = this.props.templateSettings.filter(item => {
    const messageType = this.props.isEmail ? 'email' : 'text'
    return item.message_type === messageType
  })

  render() {
    const {
      closeOptionsModal,
      openCreateTemplateModal,
      handleTemplateSelection,
      isBlastMsg,
      isEmail,
      hideImgPicker,
      previewPendingMedia,
    } = this.props

    function closeOptionsModalAndPreviewPendingMedia(img) {
      closeOptionsModal()
      previewPendingMedia(img)
    }

    const modalWrapper = cx('optionsModalWrapper', {
      emailModalWrapper: isEmail,
    })
    const modalItem = cx('optionsModalItem')
    const modalItemRow = cx('optionsModalItemRow', {
      disabled: this.filteredSettings.length === 0,
    })
    const modalItemRowActive = cx('optionsModalItemRow--active')
    const modalItemSelect = cx('selectWrapper', {
      disabled: this.filteredSettings.length === 0,
    })
    const modalItemSelectRow = cx('selectWrapperRow')
    const closeButton = cx('closeButton')

    return (
      <div
        className={modalWrapper}
        aria-modal="true"
        role="dialog"
        onMouseLeave={(event) => {
          if (event.target === event.currentTarget) {
            closeOptionsModal();
          }
        }}
      >
        {!hideImgPicker && (
          <div className={modalItem}>
            <div className={modalItemRowActive}>
              <ImageIcon />
              <ImagePicker
                extensions={['jpg', 'jpeg', 'png']}
                dims={{ maxWidth: 2000, maxHeight: 2000 }}
                onChange={img => closeOptionsModalAndPreviewPendingMedia(img)}
                onError={err => renderAlert(err)}
              >
                <div> Send an Image </div>
              </ImagePicker>
            </div>
          </div>
        )}
        {!isBlastMsg && (
          <div>
            <div className={modalItem}>
              <div className={modalItemRow}>
                <InsertTemplateIcon />
                <div className={modalItemSelectRow}>
                  <TemplateSelect
                    isEmail={isEmail}
                    filteredSettings={this.filteredSettings}
                    handleTemplateSelection={handleTemplateSelection}
                    selectionType="insert"
                  />
                  <CaratIcon />
                </div>
              </div>
            </div>
            <div className={modalItem}>
              <div
                className={modalItemRowActive}
                onClick={openCreateTemplateModal}
              >
                <CreateIcon />
                <div> Create Template </div>
              </div>
              <div className={modalItemSelect}>
                <TemplateSelect
                  isEmail={isEmail}
                  filteredSettings={this.filteredSettings}
                  handleTemplateSelection={handleTemplateSelection}
                  selectionType="update"
                />
                <CaratIcon />
              </div>
            </div>
            <div className={modalItem}>
              <div className={modalItemRow}>
                <DeleteTemplateIcon
                  color={
                    this.filteredSettings.length === 0 ? '#aaa' : '#243641'
                  }
                />
                <div className={modalItemSelectRow}>
                  <TemplateSelect
                    isEmail={isEmail}
                    filteredSettings={this.filteredSettings}
                    handleTemplateSelection={handleTemplateSelection}
                    selectionType="delete"
                  />
                  <CaratIcon />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default MessageOptionsModal



// WEBPACK FOOTER //
// ./src/components/Messages/MessageOptionsModal.js